console.log('history.js chargé');

document.addEventListener('DOMContentLoaded', function () {
    // Enregistrer le plugin ScrollTrigger avec GSAP
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        console.log('GSAP et ScrollTrigger chargés correctement.');
        gsap.registerPlugin(ScrollTrigger);

        // Fonction pour initialiser les animations
        function initAnimations() {
            // Sélectionner les images flottantes
            const floatingImages = document.querySelectorAll('.floating-image');
            console.log("floatingImages", floatingImages);

            floatingImages.forEach(image => {
                gsap.to(image, {
                    y: (i, target) => -target.offsetHeight * 0.9, // Ajustez le facteur de défilement ici
                    ease: 'none',
                    scrollTrigger: {
                        trigger: image,
                        start: 'top bottom', // Commence l'animation lorsque le haut de l'image atteint le bas de la fenêtre
                        end: 'bottom top', // Termine l'animation lorsque le bas de l'image atteint le haut de la fenêtre
                        scrub: true, // Permet à l'animation de suivre le défilement
                    },
                });
            });

            // Sélectionner les sections sub-section
            const subSections = document.querySelectorAll('.sub-section');
            console.log("subSections", subSections);

            subSections.forEach(section => {
                gsap.to(section, {
                    opacity: 1,
                    y: 0,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: section,
                        start: 'top 80%', // Commence l'animation lorsque le haut de la section atteint 80% de la hauteur de la fenêtre
                        end: 'bottom top', // Termine l'animation lorsque le bas de la section atteint le haut de la fenêtre
                        toggleActions: 'play none none none', // Joue l'animation à l'entrée et ne fait rien à la sortie
                    },
                });
            });

            // Rafraîchir ScrollTrigger pour prendre en compte tous les éléments
            ScrollTrigger.refresh();
        }

        // Initialiser les animations après un léger délai pour s'assurer que tout est chargé
        setTimeout(initAnimations, 100);
    } else {
        console.error('GSAP ou ScrollTrigger non chargé correctement.');
    }
});

document.addEventListener('DOMContentLoaded', () => {
    console.log("DOM chargé - start animations");
    const startAnimations = document.querySelectorAll('.start-animation');

    startAnimations.forEach(element => {
        gsap.from(element, {
            opacity: 0,
            y: 50,
            duration: 1,
            ease: 'power2.out',
        });
    });

    // Rafraîchir ScrollTrigger pour prendre en compte tous les éléments
    ScrollTrigger.refresh();
});